import React, { useState } from 'react';
import { useIntl } from 'umi';
import { UPLOAD_FILE_IMG_TYPE_LIST } from '../../config/constant';
import CommonBubble from '@home/components/CommonBubble';
import FileItem from './FileItem';
import ImageItem from './ImageItem';
import removeIcon from '@/pages/aigc/assets/svg/remove.svg';
import './index.scss';
import useSlideEffect from '@intelligence/pages/TrendingGames/components/GameSelect/_hooks/useSlideEffect';
import SwiperBtn from './component/SwiperBtn';

interface UploadFile {
  id: string;
  name: string;
  type: string;
  size: number;
  status: 'success' | 'uploading' | 'error';
  fileSrc: string;
  file: File;
  previewUrl: string;
}

interface ImgUploadRenderListProps {
  uploadList: UploadFile[];
  handleReUpload: (id: string) => void;
  handleRemoveItem: (id: string) => void;
  isShowSwiper?: boolean;
  listContainerRef?: React.RefObject<HTMLDivElement>;
}

const BaseImgUploadRenderList: React.FC<ImgUploadRenderListProps> = ({
  uploadList,
  handleReUpload,
  handleRemoveItem,
  listContainerRef
}) => {
  const { formatMessage } = useIntl();
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const handleDelete = (fileId: string) => {
    handleRemoveItem(fileId);
  };

  const handleClick = (data: UploadFile) => {
    const { id, status } = data;
    if (status === 'error') {
      handleReUpload(id);
    }
  };
  // chart 类 file part 仅用于 edit/refresh 时回传后端，不参与 UI 渲染
  const visibleUploadList = uploadList.filter(file => (file as any)?.file?.mimeType !== 'chart');
  return (
    <div className="dba-file-list" ref={listContainerRef}>
      {visibleUploadList.map(file => (
        <CommonBubble
          placement="top"
          key={file.id}
          content={
            file.status === 'error' ? (
              <div>{formatMessage({ id: 'dba_reupload' })}</div>
            ) : ''
          }
          overlayClassName='dba-nav-menu-overlay'
          trigger="hover"
          className="dba-upload-icon-tip"
        >
          <div
            className="dba-file-item-box"
            onMouseEnter={() => setHoveredId(file.id)}
            onMouseLeave={() => setHoveredId(null)}
          >
            <div onClick={() => handleClick(file)}>
              {UPLOAD_FILE_IMG_TYPE_LIST.includes(file.type) ? (
                <ImageItem
                  file={{ ...file, hover: hoveredId === file.id }}
                />
              ) : (
                <FileItem
                  file={{ ...file, hover: hoveredId === file.id }}
                />
              )}
            </div>
            {hoveredId === file.id && (
              <img
                className="dba-file-item-remove"
                src={removeIcon}
                onClick={() => handleDelete(file.id)}
              />
            )}
          </div>
        </CommonBubble>
      ))}
    </div>
  );
};

const FileListWithSwiper: React.FC<ImgUploadRenderListProps> = ({
  uploadList,
  handleReUpload,
  handleRemoveItem,
}) => {
  const {
    // 容器dom
    containerRef,
    // 列表容器dom
    listContainerRef,
    // 是否超宽，导致溢出隐藏、滚动
    isOverflow,
    // 左右滑动按钮禁用状态
    slideDisabledState,
    // 点击左滑按钮的回调
    handleSlideLeft,
    // 点击右滑按钮的回调
    handleSlideRight,
  } = useSlideEffect({
    othersWidth: (10 + 10) * 2 + 120,
    // 重新计算宽度的依赖
    updateDeps: [uploadList],
  });
  return (
    <div ref={containerRef} className='dba-file-swiper-list'>
      {isOverflow && (
        <SwiperBtn
          gradient
          type="prev"
          disabled={slideDisabledState.prev}
          onClick={handleSlideLeft}
          iconType='arrowleft'
        />
      )}
      <BaseImgUploadRenderList  {...{
        uploadList,
        handleReUpload,
        handleRemoveItem,
        listContainerRef,
      }} />
      {isOverflow && (
        <SwiperBtn
          gradient
          type="next"
          disabled={slideDisabledState.next}
          onClick={handleSlideRight}
          iconType='arrowleft'
        />
      )}
    </div>
  );
};

const ImgUploadRenderList: React.FC<ImgUploadRenderListProps> = ({
  uploadList,
  handleReUpload,
  handleRemoveItem,
  isShowSwiper
}) => {

  const BaseIComp = isShowSwiper ? FileListWithSwiper : BaseImgUploadRenderList;

  return <BaseIComp  {...{
    uploadList,
    handleReUpload,
    handleRemoveItem,
  }} />;

};

export default ImgUploadRenderList;
